import { entriesReducerFactory } from '@/fleet-configuration/data-fleet/reducers/entries-reducer-factory'
import { SET_PROJECT, REMOVE_ALL_PROJECTS, REMOVE_PROJECT, PROJECTS_LOADED } from './projects-actions.js'

export const projectsReducer = entriesReducerFactory(SET_PROJECT, REMOVE_ALL_PROJECTS, REMOVE_PROJECT, PROJECTS_LOADED)
